<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
    <b-card v-if="recordNotFound">
      <b>{{$t("NoRecordFound")}}</b>
      <router-link :to="'/company/staff'" class="float-right">
          <b-button variant="primary" class="primary">{{
            $t("Back")
          }}</b-button>
        </router-link>
    </b-card>
      <b-card v-else>
        <h4 class="heading float-left">{{ $t("StaffDetails") }}</h4>
        <router-link :to="'/company/staff'" class="float-right">
          <b-button variant="primary" class="primary">{{ $t("Back") }}</b-button>
        </router-link>
        <div class="export-table">
          <div class="vx-col description1">
            <b-table-simple responsive>
              <b-tbody>
                <b-tr>
                  <b-td>
                    <span class="font-semibold">{{ $t("FirstName") }}</span>
                  </b-td>
                  <b-td>
                    <span>{{ staffs.first_name }}</span>
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-td>
                    <span class="font-semibold">{{ $t("LastName") }}</span>
                  </b-td>
                  <b-td>
                    <span>{{ staffs.last_name }}</span>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>
                    <span class="font-semibold">{{ $t("Email") }}</span>
                  </b-td>
                  <b-td>
                    <span>{{ staffs.email }}</span>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>
                    <span class="font-semibold">{{ $t("ContactNumber") }}</span>
                  </b-td>
                  <b-td>
                    <span>{{ staffs.contact_number }}</span>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>
                    <span class="font-semibold">{{ $t("DepartmentName") }}</span>
                  </b-td>
                  <b-td>
                    <span>{{ departments }}</span>
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-td>
                    <span class="font-semibold">{{ $t("Role") }}</span>
                  </b-td>
                  <b-td>
                    <span>{{ roleList[staffs.user_role] }}</span>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      staffs: [],
      departments: [],
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
      roleList: this.$t("RoleList"),
      recordNotFound: false
    };
  },
  created() {
    this.getstaffs(this.$route.params.id);
  },

  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.roleList = this.$t("RoleList");
      },
    },
  },

  methods: {
    /**
     *  getstaffs method get all companies from company list
     **/

    getstaffs(id) {
      this.show = true;
      this.$store
        .dispatch("ShowStaff", id)
        .then((res) => {
          this.show = false;
          this.staffs = res.data.data;
          if (this.staffs.departments.length > 0) {
            for (var i = 0; i < this.staffs.departments.length; i++) {
              this.departments.push(this.staffs.departments[i].department_name);
            }
            this.departments = this.departments.toString();
          } else {
            this.departments = "N/A";
          }
        })
        .catch((error) => {
          this.$log.error("File : List.vue | Function : getstaffs() | Error :", error);
          this.show = false;
          if(error == "record_not_found"){
            this.recordNotFound = true
            return false;
          }

          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.space {
  margin-top: 20px;
}

.vs-row {
  padding: 10px;
}

#cancel {
}

.wrap {
  word-break: break-all;
}
.description1 td {
    border: none !important;
    padding: 10px !important;
    color: #626262;
    width: 50%
}
</style>
